<template>
  <div>
    <script
      :id=id type="text/plain"></script>
  </div>
</template>
<script>
export default {
  name: 'UE',
  data() {
    return {
      editor: null
    };
  },
  props: {
    config: {
      type: Object
    },
    id: {
      type: String,
      default: 'editor_box'
    },
    content: String,
    htmlStatus: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    const _this = this;
    let UE = window.UE;

    this.editor = UE.getEditor(this.id, this.config); // 初始化UE
    this.editor.addListener('ready', function () {
      _this.editor.setContent(_this.content || ''); // 确保UE加载完成后，放入内容。
      _this.editor.execCommand('fontsize', '16px'); //字号
      _this.editor.execCommand('fontfamily', 'arial'); //字体
      if (_this.disabled) {
        _this.editor.setDisabled();
      }
    });
    this.$nextTick(function () {
      _this.editor.addListener('keyup', function () {
        if (_this.htmlStatus) {
          _this.$emit('update:content', _this.getUEContent());
        } else {
          _this.$emit('update:content', _this.getContentTxt());
        }
        _this.$emit('change');
      });
    });
  },
  watch: {
    disabled :{
      handler(value) {
        if (value) {
          this.editor.setDisabled();
        } else {
          this.editor.setEnabled();
        }
      }
    }
  },
  methods: {
    setUEContent(data) {
      this.editor.setContent(data); // 放入内容。
    },
    getUEContent() { // 获取内容方法
      return this.editor.getContent();
    },
    getContentTxt() { // 获取不带HTML标签，纯文本
      return this.editor.getContentTxt();
    },
    clearLocalData() {
      this.editor.execCommand('clearlocaldata');
      this.editor.setContent('');
    }
  },
  destroyed() {
    this.editor.destroy();
  }
};
</script>
